import React, { useEffect, useState } from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IntegrationService } from "../../Services/IntegrationService";
import { formatDateString } from "../../Helpers/DateHelpers";
import { WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto } from "../../Repository/eventbookyapi";
import LayoutLeftMenu from "../../Components/Layout/LayoutLeftMenu";
import LeftMenuSettings from "../Account/LeftSettings";
import { TextService } from "../../Services/TextService";

const PingPaymentPaymentReport: React.FC = () => {
    const [data, setData] = useState<WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto[]>([]);
    const [loading, setLoading] = useState(false);
    const GetText = TextService.GetText;


    const fetchAllocations = async () => {
        setLoading(true);
        try {
            const result = await IntegrationService.GetAllocations();
            setData(result.payments ?? []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllocations();
    }, []);

    const columns: ColumnsType<WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto> = [
        {
            title: GetText("PingPaymentReport_ColumnReference"),
            dataIndex: "reference",
            key: "reference",
            width: 120,
            render: (v) => v ?? "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnMemberUniqueId"),
            dataIndex: "memberUniqueId",
            key: "memberUniqueId",
            width: 120,
            render: (v) => v ?? "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnFirstName"),
            dataIndex: "firstName",
            key: "firstName",
            render: (v) => v ?? "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnLastName"),
            dataIndex: "lastName",
            key: "lastName",
            render: (v) => v ?? "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnAmount"),
            dataIndex: "amount",
            key: "amount",
            render: (v) => (v !== undefined ? v : "-"),
        },
        {
            title: GetText("PingPaymentReport_ColumnSettledAt"),
            dataIndex: "settledAt",
            key: "settledAt",
            render: (v) => formatDateString(v) || "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnDisbursedAt"),
            dataIndex: "disbursedAt",
            key: "disbursedAt",
            render: (v) => formatDateString(v) || "-",
        },
        {
            title: GetText("PingPaymentReport_ColumnBankAccountNumber"),
            dataIndex: "bankAccountNumber",
            key: "bankAccountNumber",
            render: (v) => v ?? "-",
        },
    ];

    return (
        <LayoutLeftMenu title={GetText("PingPaymentReport_Title")} menu={<LeftMenuSettings selected={"integrations"} />}>
            <p>{GetText("PingPaymentReport_Description")}</p>
            <Table
                rowKey="memberId"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={{ pageSize: 20 }}
            />
        </LayoutLeftMenu>
    );
};

export default PingPaymentPaymentReport;
